import moment from 'moment'

import { dateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import { Model } from 'modules/core/lib/mobx-rest'

interface ICycle {
  [key: string]: any
}

class Cycle extends Model<ICycle> {
  static urlRoot(): string {
    return '/cycles'
  }

  get start(): moment.Moment {
    return stringToDate(this.attributes.start_at, 'backend').startOf('day')
  }

  get end(): moment.Moment {
    return stringToDate(this.attributes.end_at, 'backend').endOf('day')
  }

  get regularEnd(): moment.Moment {
    return stringToDate(this.attributes.regular_end_at, 'backend').endOf('day')
  }

  get startEndSameYear(): boolean {
    return this.start.year() === this.end.year()
  }

  get rangeLabel(): string {
    const cycleStartFormat = this.startEndSameYear ? 'ui_dm_long' : 'ui_dmy_long'
    const cycleEndFormat = 'ui_dmy_long'

    return i18n.t('time_off.cycle', {
      begin: dateToString(this.start, cycleStartFormat),
      end: dateToString(this.end, cycleEndFormat),
    })
  }

  get referenceDate(): moment.Moment {
    const today = moment()

    if (this.covers(today)) {
      return today
    }

    return today.isAfter(this.end) ? this.end : this.start
  }

  covers(date: moment.Moment): boolean {
    return date.isSameOrAfter(this.start) && date.isSameOrBefore(this.end)
  }
}

export default Cycle
